import s from './LegalInfoPage.module.scss';
import offerSalesImg from '../../../images/docsImg/doc1.png';
import privacyPolicyImg from '../../../images/docsImg/doc2.png';
import licenseAgreementImg from '../../../images/docsImg/doc3.png';
import paymentTermsImg from '../../../images/docsImg/doc4.png';
import licenseAgreement from '../../../documents/Лицензионное_соглашение.pdf';
import offerSales from '../../../documents/Оферта_продажи_программных_продуктов.pdf';
import privacyPolicy from '../../../documents/Политика_конфиденциальности.pdf';
import paymentTerms from '../../../documents/Условия_оплаты.pdf';
import { ReactComponent as IconPdf } from '../../../images/icons/pdf.svg';
import { Header } from 'components/common/Header';
import { ContentContainer } from 'components/common/ContentContainer';
import { Footer } from 'components/common/Footer';

export const LegalInfoPage = () => {
	return (
		<div className={s.legalInfoPage}>
			<Header className={s.header} isAuth={false} />

			<main>
				<ContentContainer className={s.legalInfoPage__contentContainer}>
					<section className={s.legalInfo}>
						<h2>Правовая информация</h2>

						<div className={s.legalInfo_docList}>
							<div className={s.legalInfo_docList_docBlock}>
								<img src={licenseAgreementImg} alt='doc' />

								<a href={licenseAgreement} target='_blank'>
									<IconPdf /> Лицензионное соглашение
								</a>
							</div>

							<div className={s.legalInfo_docList_docBlock}>
								<img src={offerSalesImg} alt='doc' />

								<a href={offerSales} target='_blank'>
									<IconPdf /> Оферта продажи программных продуктов
								</a>
							</div>

							<div className={s.legalInfo_docList_docBlock}>
								<img src={privacyPolicyImg} alt='doc' />

								<a href={privacyPolicy} target='_blank'>
									<IconPdf /> Политика конфиденциальности
								</a>
							</div>

							<div className={s.legalInfo_docList_docBlock}>
								<img src={paymentTermsImg} alt='doc' />

								<a href={paymentTerms} target='_blank'>
									<IconPdf /> Условия оплаты
								</a>
							</div>
						</div>
					</section>

					<section className={s.contacts}>
						<h3>Контакты</h3>

						<p>ООО "ИНФОРМАЦИОННАЯ МЕХАНИКА"</p>

						<div>
							<div>
								<span>Телефон:</span>
								<span>+7 (930) 665 65-76</span>
							</div>
							<div>
								<span>Служба поддержки:</span>
								<span>support@zennolab.com</span>
							</div>
							<div>
								<span>ОГРН:</span>
								<span>1215200009606</span>
							</div>
						</div>
					</section>
				</ContentContainer>
			</main>

			<Footer />
		</div>
	);
};
